import React, { useState, useEffect, Fragment } from 'react';
import '../TabActivities.scss';
import Button from '../../../partials/Button';
import Scroll from '../../../partials/Scroll/Scroll';
import Media from '../../../partials/Media';

const Tabs = (props) => {

  const { data } = props;

  const [currentStep, setCurrentStep] = useState(0);
  const [ subtabstate, setsubtabstate ] = useState(0);
  const [ resultTabState, setResultTabState ] = useState(0);
  const [ subwindowbtstate, setsubwindowbtstate ] = useState(0);
  // This are the subbuttontabs without filtering
  const [ subTabs, setSubTabs ] = useState([]);
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    let helper = [];
    data.tabs.map(tab => {
      tab.subbuttontab && tab.subbuttontab.map(sb => {
        helper.push(sb)
      })
    })
    console.log(helper)
    setSubTabs(helper)
  }, [])

  const nexttab = () => {
    if(currentStep<data.tabs.length-1){
      setsubtabstate(0);
      setsubwindowbtstate(0);
      setCurrentStep(currentStep+1);
    } else {
      setCompleted(true);
    }
    setResultTabState(0);
  }
   
  return (
    <div>
      { data.tabs.map( (tab, tabIndex) => (
      currentStep==tabIndex&&
        <div className="modes-of-operation-Activity">
          <div className="panel">
            <div className="left-panel-Activity">
              <div className=""> 
                {/* <div className={`QuestionHeader`}>Question {tabIndex} of {data.tabs.length-1}</div> */}
                <div className="exploreContentHeader">
                  {/* <Scroll> */}
                  {data?.headerText}
                  {/* </Scroll> */}
                </div>
              </div>
              <div className="TextColor QuestionHeader" dangerouslySetInnerHTML={{ __html: tab.content }}></div>
              {/* <div > */}
                <Scroll>
                  <div className="optionContainer">
                    {tab.options.map((subbuttontab, subbuttontabindex)=>(
                    <div className={`activity-Mod-button ${subtabstate==subbuttontabindex+1? 'activity-Mod-button-active-right' : ''}`} onClick={()=>setsubtabstate(subbuttontabindex+1)} dangerouslySetInnerHTML={{ __html: subbuttontab.options }}></div>
                  ))}
                </div>
                </Scroll>
              {/* </div> */}
                <div className="ButtonDiv">
                  <Button text="SUBMIT" disabled={subtabstate!=0?false:true}onClick={()=>setResultTabState(resultTabState+1)}/>
                </div>
              <div>
                {resultTabState!=0 && 
                  <div className="feedback-container">
                    <div className="Resultboxsizing">
                      <p className={`resultDetails ${tab.results[subtabstate-1].correct?'rightHeader':'wrongHeader'}`} dangerouslySetInnerHTML={{ __html: tab.results[subtabstate-1].title }}></p>
                      <br/>
                      <Scroll>
                        <div className="feedback-text-container">
                          <p className="TextColor resultDetails" dangerouslySetInnerHTML={{ __html: tab.results[subtabstate-1].content }}></p>
                        </div>
                      </Scroll>
                      <div className="feedback-ButtonDiv">
                        <Button text="Next" onClick={()=>nexttab()}/>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
            <div className="right-panel-Activity">
              <div className="modes-of-operation-Activity-subwidnows">
                <div>
                  <div className="panel">
                    <div className="left-panel-Activity-subwidnows">
                      <Scroll>
                        <div className="mod-btn-container">
                          {subTabs.map((subbuttontab, subbuttontabindex)=>(
                            <button className={`activity-Mod-button-subwindow ${subwindowbtstate==subbuttontabindex? 'activity-Mod-button-active-right-subwindow' : ''}`} onClick={()=>setsubwindowbtstate(subbuttontabindex)}>{subbuttontab.buttonName}</button>
                          ))}
                        </div>
                      </Scroll>
                    </div>
                    <div className="boxsizing boxsizing1">
                      <div className="right-panel-Activity-subwidnows">
                        {subTabs.map((subbuttontab, subbuttontabindex)=>(
                          subwindowbtstate==subbuttontabindex &&
                          <div>
                            { subbuttontab.img !== 0 &&
                              <div className="MiniImage">
                                <Media src={subbuttontab.img} style={{width: `60%`, margin: `auto`}}/>
                              </div>
                            }
                            <Scroll><div className="rightsubcontent" dangerouslySetInnerHTML={{ __html: subbuttontab.content }}/></Scroll>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="nextBtn">
              <Button 
                text="Next"
                disabled={!completed}
                onClick={()=> props.onComplete()}/>
            </div>
          </div>
        </div> 
      ))} 
    </div>    
  );
};

export default Tabs;